<script setup lang="ts">
import { computed } from 'vue';
import { alignmentClasses, justificationClasses, type UiAlignment, type UiJustification } from '../ui-layout/classes';

type ButtonGroupLayout = 'inline' | 'responsive' | 'stacked';

const props = withDefaults(defineProps<{
    layout?: ButtonGroupLayout;
    align?: UiAlignment;
    justify?: UiJustification;
}>(), {
    layout: 'inline',
    align: 'center',
    justify: 'start'
});

const layoutClasses: Record<ButtonGroupLayout, string> = {
    inline: 'inline-flex flex-wrap',
    responsive: 'flex w-full flex-col sm:w-auto sm:flex-row sm:flex-wrap',
    stacked: 'flex flex-col'
};

const classes = computed(() => [
    'gap-2',
    layoutClasses[props.layout],
    alignmentClasses[props.align],
    justificationClasses[props.justify]
]);
</script>

<template>
    <div :class="classes">
        <slot name="default" />
    </div>
</template>
